import * as Sentry from '@sentry/angular-ivy';
import { SENTRY_CONFIG, SentryConfig } from './sentry-tokens';
import { APP_INITIALIZER, inject } from '@angular/core';

export const initSentry = (sentryConfig: SentryConfig) => {
    if (sentryConfig?.enabled) {
        if (!sentryConfig?.dsn) {
            throw new Error(
                'Sentry initialization attempted without configuration for dsn value. Was SENTRY_CONFIG added to providers and configured?',
            );
        }
        Sentry.init({
            dsn: sentryConfig?.dsn,
            environment: sentryConfig?.environment,
            integrations: [
                ...(sentryConfig?.allowSessionReplay
                    ? [new Sentry.Replay()]
                    : []),
            ],
            replaysSessionSampleRate: sentryConfig?.replaysSessionSampleRate,
            replaysOnErrorSampleRate: sentryConfig?.replaysOnErrorSampleRate,
        });
    }
};

/**
 * For providing Sentry in apps that need to implement a custom error handler.
 */
export const sentryProvidersInitOnly = [
    {
        provide: APP_INITIALIZER,
        useFactory: () => {
            const sentryConfig = inject(SENTRY_CONFIG);
            return () => initSentry(sentryConfig);
        },
        multi: true,
    },
];
